t = require('views/internal/teacup-with-helpers')('board_sidebar')

module.exports = t.renderable ({ useTabs, canAddPowerUps, canAddStickers }) ->
  if useTabs
    t.div '.board-menu-tabs', ->
      t.div '.board-menu-tab.js-hide-sidebar', ->
        t.span '.icon-lg.icon-close'
      t.div '.board-menu-tab.js-open-members.js-tab', { 'data-name': 'default' }, ->
        t.span '.icon-lg.icon-member'
        t.span '.board-menu-tab-text', ->
          t.format 'people'
      t.div '.board-menu-tab.js-open-activity.js-tab', { 'data-name': 'activity' }, ->
        t.span '.icon-lg.icon-activity'
        t.span '.board-menu-tab-text', ->
          t.format 'activity'
      if canAddPowerUps
        t.div '.board-menu-tab.js-open-power-ups.js-tab', { 'data-name': 'powerUps' }, ->
          t.span '.icon-lg.icon-power-up'
          t.span '.board-menu-tab-text', ->
            t.format 'power-ups'
      t.div '.board-menu-tab.js-open-filter.js-tab', { 'data-name': 'filter' }, ->
        t.span '.icon-lg.icon-filter'
        t.span '.board-menu-tab-text', ->
          t.format 'filter'
      if canAddStickers
        t.div '.board-menu-tab.js-open-stickers.js-tab', { 'data-name': 'stickers' }, ->
          t.span '.icon-lg.icon-sticker'
          t.span '.board-menu-tab-text', ->
            t.format 'stickers'
      t.div '.board-menu-tab.js-open-settings.js-tab', { 'data-name': 'settingsAndMore' }, ->
        t.span '.icon-lg.icon-gear'
        t.span '.board-menu-tab-text', ->
          t.format 'settings'

  t.div '.board-menu-tab-content', ->
    t.div '.board-menu-header.js-board-menu-title', ->

      t.div '.board-menu-header-content', ->
        t.a '.board-menu-header-back-button.icon-lg.icon-back.js-pop-widget-view', { href: '#', title: t.l('go-back') }

        if useTabs
          t.div '.board-menu-header-icon.js-board-menu-title-icon'

        t.h3 '.board-menu-header-title.js-board-menu-title-text', {
          class: t.classify('align-left': useTabs)
        }

        if useTabs
          t.div '.board-menu-header-extra.js-board-menu-title-extra'

        if !useTabs
          t.a '.board-menu-header-close-button.icon-lg.icon-close.js-hide-sidebar', { href: '#', title: t.l('close-the-board-menu') }

      t.hr '.board-menu-header-divider'

    t.div '.board-menu-content.u-fancy-scrollbar.js-board-menu-content-wrapper'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/board_sidebar.coffee